import { MICROSERVICE_CONFIG } from "../../config/configs";
import { authenticatedApi } from "../api";

export const getPromoGifts = async (payload) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.SUPERADMIN_BFF}/gifts?${payload}`
	);
	return response.data;
};

export const getPromoGiftsApprovalRequests = async (payload) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.SUPERADMIN_BFF}/restaurant-gifts/admin/approval${
			payload ? `?${payload}` : ""
		}`
	);
	return response.data;
};

export const approvePromoGiftsRequest = async (payload) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.GIFT}/restaurant-gifts/admin/approval`,
		payload
	);
	return response.data;
};
